<template>
  <CustomTable :columns="columnsToPrescription" :openModal="handleOpen" type="Prescription" />
  <!-- 弹出框 -->
  <the-detail
    v-model:visible="visible"
    :serialNumber="modalData.serialNumber"
    :recordType="modalData.recordType"
  />
</template>

<script setup>
import CustomTable from './CustomTable.vue'
import { columnsToPrescription } from '@/components/PatientFile/ModalBody/todo/config'
import { reactive, ref } from 'vue'
import TheDetail from '@/components/TheDetail/index.vue'
const visible = ref(false)
const modalData = reactive({
  serialNumber: null,
  recordType: 'prescriptionGroup'
})

const handleOpen = data => {
  visible.value = true
  modalData.serialNumber = data.record.prescriptionSn
}
</script>

<style lang="scss" scoped></style>
